import {useUser} from "../../../context/UserContext";
import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import EmptyLine from "../EmptyLine";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultRow from "../../../components/table/ResultRow";
import HecRasHelper from "../../../helpers/HecRasHelper";
import ResultBody from "../../../components/table/ResultBody";
import CheckCSName from "../CheckCSName";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import ResultView from "../../../components/ResultView";

export function FL1({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.FL03.error_id: {
            return (
                <>
                    <ResultText>
                        Flow changes with more than {settings?.thresholds?.flow_change_rate}% are highlighted in the flow table.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15)}}></ResultHeaderCell>
                                <ResultHeaderCell colSpan={row?.profiles?.length} style={{width: HecRasHelper.getWidth(row?.profiles?.length*10), textAlign: 'center'}}>Flow Rate Change (%)</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{width: HecRasHelper.getWidth(15), textAlign: 'start'}}>River Station</ResultHeaderCell>
                                {
                                    row?.profiles?.map(p => (
                                        <ResultHeaderCell style={{width: HecRasHelper.getWidth(8), textAlign: 'start'}}>{p}</ResultHeaderCell>
                                    ))
                                }
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{width: HecRasHelper.getWidth(15)}}>
                                            <CheckCSName csName={r.cross_section} />
                                        </ResultBodyCell>
                                        {
                                            r?.flow_changes?.map(fc => (
                                                <ResultBodyCell style={{color: Math.abs(fc?.flow_change) > settings?.thresholds?.flow_change_rate ? 'red': '', textAlign: 'start'}}>
                                                    {fc?.flow_change}
                                                </ResultBodyCell>
                                            ))
                                        }
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
    }
}